import React, {Dispatch, SetStateAction, useState} from 'react';
import {FormOperacionCorporateLendingDetalle} from "../types/types";
import {useConfirmationDialog} from "../../../../../hooks/useConfirmationDialog";
import {Box, Card, CardContent, IconButton, Stack, Tooltip} from "@mui/material";
import {UseFormReturn} from "react-hook-form";
import DeleteIcon from "@mui/icons-material/Delete";
import CorporateLendingDetalle from "./CorporateLendingDetalle";
import CorporateLendingDetalleForm from "./CorporateLendingDetalleForm";


interface SeccionCorporateLendingDetalleNuevoProps {
  codPais: number,
  formMethods: UseFormReturn<FormOperacionCorporateLendingDetalle>,
  detalleProvisional?: FormOperacionCorporateLendingDetalle,
  setDetalleProvisional: Dispatch<SetStateAction<FormOperacionCorporateLendingDetalle | undefined>>,
}

function SeccionCorporateLendingDetalleNuevo({
                                               codPais,
                                               detalleProvisional,
                                               setDetalleProvisional,
                                               formMethods
                                             }: SeccionCorporateLendingDetalleNuevoProps) {
  const {askConfirmation} = useConfirmationDialog();

  const [openDialog, setOpenDialog] = useState<boolean>(false);

  const {control, handleSubmit, reset} = formMethods;

  const alGuardarDetalleProvisional = (data: FormOperacionCorporateLendingDetalle) => {
    setDetalleProvisional(data);
    reset();
    setOpenDialog(false);
  };

  return (
    <>
      {
        !detalleProvisional ? (
          <CorporateLendingDetalleForm codPais={codPais} formMethods={formMethods}
                                       onSubmitForm={alGuardarDetalleProvisional}/>
        ) : (
          <Stack>
            <Card key={'corporate-lending-detalle'}>
              <Box display='flex' justifyContent='flex-end'>
                <Tooltip title='Eliminar'>
                  <IconButton
                    onClick={() =>
                      askConfirmation(() =>
                        setDetalleProvisional(undefined as unknown as FormOperacionCorporateLendingDetalle)
                      )
                    }
                  >
                    <DeleteIcon color='error'/>
                  </IconButton>
                </Tooltip>
              </Box>
              <CardContent>
                <CorporateLendingDetalle detalle={detalleProvisional}/>
              </CardContent>
            </Card>
          </Stack>
        )
      }
    </>
  );
}

export default SeccionCorporateLendingDetalleNuevo;